















import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: 'SearchResultsCount',
  props: {
    details: {type: Array as PropType<String[]>}
  }
})
